<template>
  <b-col class="company-details-holder">
    <div class="company-details rounded company-details-vali-hollow-logo">
      <div class="company-grid">
        <template v-if="selectedCompany.founded_at">
          <div class="label">Alapítás éve</div>
          <div class="value">
            {{ selectedCompany.founded_at.slice(0, 4) }}
          </div>
        </template>

        <template v-if="selectedCompany.tax_number && selectedCompany.tax_number.length > 0">
          <div class="label">Adószám</div>
          <div class="value">
            {{ selectedCompany.tax_number[0].tax_number }}
          </div>
        </template>

        <template
          v-if="
            selectedCompany.main_activities &&
              selectedCompany.main_activities.length > 0 &&
              selectedCompany.main_activities[0].nace_name
          "
        >
          <div class="label">Fő tevékenység</div>
          <div class="value">
            {{ getCompanyMainActivity }}
          </div>
        </template>

        <template v-if="computedLastYearArbevetel && computedLastYearArbevetel.value">
          <div class="label">Előző éves nettó árbevétel</div>
          <div class="value">
            {{ computedLastYearArbevetel.value | toCurrency }}
            {{ computedLastYearArbevetel.currency }}
          </div>
        </template>

        <template v-if="computedLastYearMerlegEredmeny && computedLastYearMerlegEredmeny.value">
          <div class="label">Előző éves mérleg eredmény</div>
          <div class="value">
            {{ computedLastYearMerlegEredmeny.value | toCurrency }}
            {{ computedLastYearMerlegEredmeny.currency }}
          </div>
        </template>

        <template v-if="computedLastEBITDA && computedLastEBITDA !== ''">
          <div class="label">Előző éves EBITDA</div>
          <div class="value">
            {{ computedLastEBITDA.value | toCurrency }}
            {{ computedLastEBITDA.currency }}
          </div>
        </template>

        <template v-if="computedLastYearExportRevenue && computedLastYearExportRevenue !== ''">
          <div class="label">Előző éves export értékesítés nettó árbevétele</div>
          <div class="value">
            {{ computedLastYearExportRevenue.value | toCurrency }}
            {{ computedLastYearExportRevenue.currency }}
          </div>
        </template>

        <template v-if="computedLastYearEszkozok && computedLastYearEszkozok.value">
          <div class="label">Előző éves mérlegfőösszeg</div>
          <div class="value">
            {{ computedLastYearEszkozok.value | toCurrency }}
            {{ computedLastYearEszkozok.currency }}
          </div>
        </template>

        <template v-if="computedLastYearToke && computedLastYearToke.value">
          <div class="label">Előző éves saját tőke</div>
          <div class="value">
            {{ computedLastYearToke.value | toCurrency }}
            {{ computedLastYearToke.currency }}
          </div>
        </template>

        <template
          v-if="
            selectedCompany.registered_capital &&
              selectedCompany.registered_capital.data &&
              selectedCompany.registered_capital.data.length > 0
          "
        >
          <div class="label">Jegyzett tőke</div>
          <div class="value">
            {{ numberWithSpace(computedCapital.amount) }}
            {{ computedCapital.currency }}
          </div>
        </template>

        <template v-if="selectedCompany.address && selectedCompany.address.length > 0">
          <div class="label">Székhely</div>
          <div class="value">
            {{ selectedCompany.address[0].address }}
          </div>
        </template>

        <template v-if="selectedCompany.sites && selectedCompany.sites.length > 0">
          <div class="label">Telephelyek ({{ selectedCompany.sites.length }} db)</div>

          <div class="value">
            <p v-for="(site, index) in selectedCompany.sites.slice(0, 5)" :key="index">
              {{ site.address }}
            </p>

            <div v-if="showAllSite">
              <p v-for="(site, index) in selectedCompany.sites.slice(5)" :key="'more-site-' + index">
                {{ site.address }}
              </p>
            </div>

            <p v-if="selectedCompany.sites.length > 5 && !showAllSite">
              <strong @click="showSites" style="cursor: pointer">
                További {{ selectedCompany.sites.length - 5 }} telephely..
              </strong>
            </p>
          </div>
        </template>

        <template v-if="selectedCompany.branches && selectedCompany.branches.length > 0">
          <div class="label">Fióktelepek ({{ selectedCompany.branches.length }} db)</div>

          <div class="value">
            <p v-for="(branch, index) in selectedCompany.branches.slice(0, 5)" :key="index">
              {{ branch.address }}
            </p>

            <div v-if="showAllBranch">
              <p v-for="(branch, index) in selectedCompany.branches.slice(5)" :key="'more-branch-' + index">
                {{ branch.address }}
              </p>
            </div>

            <p v-if="selectedCompany.branches.length > 5 && !showAllBranch">
              <strong @click="showBranches" style="cursor: pointer">
                További {{ selectedCompany.branches.length - 5 }} fióktelep..
              </strong>
            </p>
          </div>
        </template>

        <template
          v-if="
            selectedCompany.head_count &&
              selectedCompany.head_count.length > 0 &&
              selectedCompany.head_count[0].count != null
          "
        >
          <div class="label">Átlagos statisztikai létszám</div>
          <div class="value">{{ selectedCompany.head_count[0].count }} fő</div>
        </template>
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    selectedCompany: { type: Object, required: true }
  },
  data() {
    return {
      showAllBranch: false,
      showAllSite: false
    }
  },
  computed: {
    getCompanyMainActivity() {
      if (!this.selectedCompany.main_activities || !this.selectedCompany.main_activities.length) {
        return null
      }

      if (this.selectedCompany.main_activities.length === 1) {
        return this.selectedCompany.main_activities[0].nace_name
      }

      const filterDeletion = this.selectedCompany.main_activities.filter(activity => {
        return activity.deletion === undefined
      })

      return filterDeletion.length > 0 ? filterDeletion[0].nace_name : null
    },

    computedLastEBITDA() {
      if (this.selectedCompany.financeData && this.selectedCompany.financeData.length) {
        const EBITDA = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'EBITDA')

        if (EBITDA && EBITDA.data && EBITDA.data.length > 0) {
          const lastYearEBITDA = EBITDA.data[EBITDA.data.length - 1]

          return {
            value: lastYearEBITDA.value * lastYearEBITDA.multiplier,
            currency: lastYearEBITDA.currency
          }
        }
      }

      return ''
    },

    computedLastYearExportRevenue() {
      if (this.selectedCompany.financeData && this.selectedCompany.financeData.length) {
        const exportRevenue = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Exportértékesítés nettó árbevétele'
        )

        if (exportRevenue && exportRevenue.data && exportRevenue.data.length > 0) {
          const lastYearExportRevenue = exportRevenue.data[exportRevenue.data.length - 1]

          return {
            value: lastYearExportRevenue.value * lastYearExportRevenue.multiplier,
            currency: lastYearExportRevenue.currency
          }
        }
      }

      return ''
    },

    computedLastYearEszkozok() {
      if (this.selectedCompany.financeData && this.selectedCompany.financeData.length) {
        const eszkozok = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Eszközök összesen')

        if (eszkozok && eszkozok.data && eszkozok.data.length > 0) {
          const lastYearEszkozok = eszkozok.data[eszkozok.data.length - 1]

          return {
            value: lastYearEszkozok.value * lastYearEszkozok.multiplier,
            currency: lastYearEszkozok.currency
          }
        }
      }

      return ''
    },

    computedLastYearToke() {
      if (this.selectedCompany.financeData && this.selectedCompany.financeData.length) {
        const toke = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Saját tőke')

        if (toke && toke.data && toke.data.length > 0) {
          const lastYearToke = toke.data[toke.data.length - 1]

          return {
            value: lastYearToke.value * lastYearToke.multiplier,
            currency: lastYearToke.currency
          }
        }
      }

      return ''
    },

    computedLastYearArbevetel() {
      if (this.selectedCompany.financeData && this.selectedCompany.financeData.length) {
        const income = this.selectedCompany.financeData.find(financeItem => financeItem.name === 'Árbevétel')

        if (income && income.data && income.data.length > 0) {
          const lastYearIncome = income.data[income.data.length - 1]

          return {
            value: lastYearIncome.value * lastYearIncome.multiplier,
            currency: lastYearIncome.currency
          }
        }
      }

      return ''
    },

    computedLastYearMerlegEredmeny() {
      if (this.selectedCompany.financeData && this.selectedCompany.financeData.length) {
        const profitAfterTax = this.selectedCompany.financeData.find(
          financeItem => financeItem.name === 'Adózott eredmény'
        )

        if (profitAfterTax && profitAfterTax.data && profitAfterTax.data.length > 0) {
          const lastYearResultAfterTax = profitAfterTax.data[profitAfterTax.data.length - 1]

          return {
            value: lastYearResultAfterTax.value * lastYearResultAfterTax.multiplier,
            currency: lastYearResultAfterTax.currency
          }
        }
      }

      return ''
    },

    computedCapital() {
      if (
        this.selectedCompany.registered_capital &&
        this.selectedCompany.registered_capital.data &&
        this.selectedCompany.registered_capital.data.length > 0
      ) {
        return {
          amount:
            this.selectedCompany.registered_capital.data[this.selectedCompany.registered_capital.data.length - 1]
              .value *
            this.selectedCompany.registered_capital.data[this.selectedCompany.registered_capital.data.length - 1]
              .multiplier,

          currency: this.selectedCompany.registered_capital.data[
            this.selectedCompany.registered_capital.data.length - 1
          ].currency
        }
      }

      return {
        amount: '',
        currency: ''
      }
    }
  },

  methods: {
    numberWithSpace(number) {
      if (number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      }
    },

    showBranches() {
      this.showAllBranch = true
    },

    showSites() {
      this.showAllSite = true
    }
  }
}
</script>

<style scoped>
.company-details {
  background-color: white;
  color: var(--color-gray-04);
  text-align: left;
  padding: 15px;
  border: 1px solid var(--color-gray-02);
}

.company-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.label,
.value {
  padding: 15px;
}

.label {
  font-weight: bold;
}

.company-grid > .label:nth-of-type(4n + 3),
.company-grid > .label:nth-of-type(4n + 4),
.company-grid > .value:nth-of-type(4n + 3),
.company-grid > .value:nth-of-type(4n + 4) {
  background-color: var(--color-lightgreen);
}

.company-details-vali-hollow-logo {
  position: relative;
  overflow: hidden;
}

button {
  width: 250px;
  height: 48px;
  font-weight: bold;
}

@media (max-width: 993px) {
  .company-grid {
    grid-template-columns: 1fr;
  }

  .company-details-holder {
    padding-left: 0;
    padding-right: 0;
  }

  .company-details {
    border: 0 !important;
  }
}
</style>
